module.exports = __webpack_public_path__ + "img/sixpackcarrier92.310e45c0.jpg";